/* eslint-disable @typescript-eslint/no-explicit-any */
export const setBagTypes = (dispatch: any, data: any) => {
  dispatch({
    type: "SET_BAG_TYPES",
    payload: [...data],
  });
};

export const setCoinContainers = (dispatch: any, data: any) => {
  dispatch({
    type: "SET_COIN_CONTAINERS",
    payload: [...data],
  });
};

export const setCurrencyList = (dispatch: any, data: any) => {
  dispatch({
    type: "SET_CURRENCY_LIST",
    payload: [...data],
  });
};
